import { useCallback, useState } from "react";

export type CostTooltipPhase = "idle" | "open" | "closing";

export function useCostTooltipHeaderPhase() {
	const [phase, setPhase] = useState<CostTooltipPhase>("idle");

	const onCostCellEnter = useCallback(() => {
		setPhase("open");
	}, []);

	const onCostCellLeave = useCallback(() => {
		setPhase((p) => (p === "open" ? "closing" : p));
	}, []);

	const onCostTooltipCloseAnimationEnd = useCallback(() => {
		setPhase((p) => (p === "closing" ? "idle" : p));
	}, []);

	const phaseClasses =
		phase === "open"
			? " window-header-item--cost-tooltip-visible"
			: phase === "closing"
				? " window-header-item--cost-tooltip-closing"
				: "";

	return {
		onCostCellEnter,
		onCostCellLeave,
		onCostTooltipCloseAnimationEnd,
		phaseClasses,
	};
}
